import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps } from 'theme/jss-types';
import { useTranslation } from 'react-i18next';
import { Col, Form, Radio } from 'antd';
import { formRules } from 'library/constants';

const styles = () => ({
    referenceItem: {
        display: 'flex',
        flexDirection: 'column',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    formItem: {
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    params: any;
    field: any;
}

const ItemTypeField = (props: IProps) => {
    const { t, i18n } = useTranslation();
    const {
        showItemType,
        classes,
        params,
        field,
        loadTypeOptions,
    } = props;
    const { getValidationRules, getIsRequiredValidation, disabledFields = {} } = params;

    const formRuleRequired = {
        ...formRules.required,
        message: i18n.exists('required') ? t('required') : 'Required',
    };

    if (!showItemType) {
        return <></>;
    }

    const options = loadTypeOptions || field.options;
    const translatedOptions = Array.isArray(options) && options.length > 0
        ? options.map((item: any) => ({
            ...item,
            label: t(item.value),
        }))
        : options;
    return (
        <Col span={24} xs={24} sm={24} md={12}>
            <div className={classes.referenceItem}>
                <div className={classes.referenceTitle}>
                    {t(field.key)}
                    <span>{getIsRequiredValidation(field.key) ? '*' : ''}</span>
                </div>
                <Form.Item
                    name={field.key}
                    initialValue={field.defaultValue}
                    valuePropName={field.valuePropName}
                    rules={[formRuleRequired, ...getValidationRules(field)]}
                    className={classes.formItem}
                >
                    <Radio.Group
                        options={translatedOptions}
                        disabled={!!disabledFields[field.key]}
                        // onChange={(e) => setItemType(e.target.value)}
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    />
                </Form.Item>
            </div>
        </Col>
    );
};

const mapStateToProps = (state: any) => {
    const { master } = state;
    const { config } = master;
    const consignmentConfig = config?.customer_portal_consignment_config;
    const partsToShowSingleConsignment = consignmentConfig?.parts_to_show_single_consignment;
    const showItemType = partsToShowSingleConsignment?.itemType !== false;
    const loadTypeOptions = config?.load_type_options;
    return {
        showItemType,
        loadTypeOptions,
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(ItemTypeField);
